import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=checking, null=anonymous, object=logged in
  const [shop, setShop] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      try {
        const res = await api.get("/shops/mine");
        setShop(res.data);
      } catch { setShop(null); }
    } catch {
      setUser(null);
      setShop(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (identifier, password) => {
    try {
      const { data } = await api.post("/auth/login", { identifier, password });
      if (data.access_token) setAuthToken(data.access_token);
      setUser(data.user);
      try { const s = await api.get("/shops/mine"); setShop(s.data); } catch {}
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) };
    }
  };

  const register = async (payload) => {
    try {
      const { data } = await api.post("/auth/register", payload);
      if (data.access_token) setAuthToken(data.access_token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setAuthToken(null);
    setUser(null);
    setShop(null);
  };

  return (
    <AuthContext.Provider value={{ user, shop, login, register, logout, refresh, setShop }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth inside AuthProvider");
  return ctx;
}
